<template>
  <form ref="form" autocomplete="off" class="tf" @submit.prevent>
    <ValidationObserver ref="observer" v-slot="{}">
      <div class="tf-row">
        <span class="tf-label">Title</span>
        <ValidationProvider v-slot="{ errors }" rules="required" name="title" ref="update_title">
          <input v-model="update_title" class="tf-input" :class="{ error: errors.length }" placeholder="Update title" @keypress="onKeyPress"/>
          <span v-if="errors.length" class="tf-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="tf-row">
        <span class="tf-label">Details</span>
        <ValidationProvider v-slot="{ errors }" rules="required" name="details" ref="update_details">
          <input v-model="update_details" class="tf-input" :class="{ error: errors.length }" placeholder="Update details" @keypress="onKeyPress"/>
          <span v-if="errors.length" class="tf-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </ValidationObserver>
  </form>
</template>
<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'

export default {
  props: {
    chat_id: {
      type: String,
      default: ""
    },
    message_send: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    update_title: null,
    update_details: null,
    v: {
      title: null,
      details: null
    },
  }),
  watch: {
    async update_title() {
      const self = this;
      self.v.title = await self.$refs.update_title.validate();
      self.v.title = self.v.title.valid;
      self.validate();
    },
    async update_details() {
      const self = this;
      self.v.details = await self.$refs.update_details.validate();
      self.v.details = self.v.details.valid;
      self.validate();
    },
    message_send(update) {
      if (update) {
        this.update_title = null;
        this.update_details = null;
        this.v.title = null;
        this.v.details = null;
      }
    },
    defaultValue: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.event_title = val.event.title;
        }
      },
      deep: true
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    if (this.defaultValue && Object.keys(this.defaultValue).length > 0) {
      this.update_title = this.defaultValue.update.title;
      this.update_details = this.defaultValue.update.details;
      this.v.title = true;
      this.v.details = true;

      this.validate();
    }
  },
  methods: {
    async onKeyPress(event) {
      const self = this;
      if (event.key === "Enter") {
        self.$emit("pressEnter");
      }
    },
    setter(isValid) {
      const self = this;
      var param = {
        type: 'update',
        message: {
          chat_id: self.chat_id,
          title: self.update_title,
          details: self.update_details,
          type: 'update',
        },
        isValid: isValid,
      };
      self.$emit("setter", param);
    },

    validate() {
      const self = this;
      var isValid = false;
      if (self.v.title && self.v.details) {
        isValid = true;
      }
      self.setter(isValid);
    },
  },

}
</script>
<style scoped lang="scss">
@import '../_variables';

.tf {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  > span { display: flex; flex-direction: column; gap: 6px; }
}

.tf-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  span { display: block; }
}

.tf-label {
  font-size: 10px;
  font-weight: 600;
  color: $t3;
  font-family: $font;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tf-input {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid $border;
  border-radius: 6px;
  background: #fff;
  font-size: 11px;
  font-family: $font;
  color: $t1;
  outline: none;
  transition: border-color 0.15s;
  &::placeholder { color: $t4; }
  &:focus { border-color: $accent; }
  &.error { border-color: #ff3b30; }
}

.tf-error {
  font-size: 10px;
  color: #ff3b30;
  font-family: $font;
}

@media (max-width: 480px) {
  .tf { padding: 5px 8px; gap: 4px; > span { gap: 4px; } }
  .tf-label { font-size: 8px; }
  .tf-input { height: 24px; font-size: 10px; padding: 0 6px; border-radius: 5px; }
  .tf-error { font-size: 8px; }
}
@media (max-width: 360px) {
  .tf { padding: 3px 5px; gap: 3px; > span { gap: 3px; } }
  .tf-label { font-size: 7px; letter-spacing: 0.2px; }
  .tf-input { height: 20px; font-size: 9px; padding: 0 4px; border-radius: 4px; }
  .tf-error { font-size: 7px; }
}
@media (max-width: 280px) {
  .tf { padding: 2px 3px; gap: 2px; > span { gap: 2px; } }
  .tf-label { font-size: 6px; }
  .tf-input { height: 18px; font-size: 8px; padding: 0 3px; border-radius: 3px; }
}
</style>
